const round2 = (n) => Math.round(n * 100) / 100;

/** The discount running on this menu item right now (the API sends only a running one), or null. */
export const runningDiscount = (item) => {
  const discount = Array.isArray(item?.discounted) ? item.discounted[0] : null;
  return discount && Number(discount.discount_value) > 0 ? discount : null;
};

const typeOf = (discount) => String(discount?.discount_type || "").toLowerCase();

/**
 * What an order line costs after the discount, worked out the way the server does when the order
 * is placed: the percentage comes off the whole line, a fixed amount comes off every unit, the
 * result never goes below zero and is rounded once to two decimals. Only a percentage or a fixed
 * amount changes the price.
 */
export const discountedLineTotal = (unitPrice, quantity, discount) => {
  const units = Number(quantity) || 0;
  const line = (Number(unitPrice) || 0) * units;
  const value = Number(discount?.discount_value) || 0;
  let total = line;
  if (typeOf(discount) === "percentage") total = line * (1 - value / 100);
  else if (typeOf(discount) === "fixed_amount") total = line - value * units;
  return round2(Math.max(0, total));
};

/** One unit's price after the discount (a line of one). */
export const discountedUnitPrice = (unitPrice, discount) => discountedLineTotal(unitPrice, 1, discount);

/** True when the discount lowers the price (a percentage or fixed amount). */
export const cutsPrice = (discount) => ["percentage", "fixed_amount"].includes(typeOf(discount));

/** The badge text: "-15%", "-₪5", or the generic sale word for any other kind. */
export const discountLabel = (discount, currencySymbol, saleWord) => {
  const value = Number(discount?.discount_value) || 0;
  const shown = Number.isInteger(value) ? String(value) : String(round2(value));
  if (typeOf(discount) === "percentage") return `-${shown}%`;
  if (typeOf(discount) === "fixed_amount") return `-${currencySymbol}${shown}`;
  return saleWord;
};
